import HttpClient from "../HttpClient";
import RazorpayPayment from "../interfaces/razorpayPayment";

export default class OneMealServiceTimeExtensionService {
    async getTimeExtensionDetails(extensionId: number) {
        const res = await HttpClient.get(`/customers/one-meal-service/time-extension/${extensionId}`);
        return res?.data;
    }

    async initiatePayment(extensionId: number, payload?: any) {
        const res = await HttpClient.post(`/customers/one-meal-service/time-extension/${extensionId}/razorpay-order`, payload);
        return res?.data;
    }

    async updatePaymentStatus(extensionId: number, data: RazorpayPayment) {
        const res = await HttpClient.patch(`/customers/one-meal-service/time-extension/${extensionId}/razorpay-order`, data);
        return res?.data;
    }
}
